import { DrinksPerDay } from "@dcc/types/drinkingDay";
import { getUnitsForTargetPercentage } from "@dcc/lookup/unitdistribution/unitdistribution";
import { getCaloriesFromUnitsForEachDay } from "@dcc/score/slider";
import { getCaloriesAndUnitsForEachday } from "@dcc/score/daily";

export const getCaloriesAndUnitsPerDay = ({
  targetPercentage, //this is the slider percentage
  gender,
  days
}: {
  targetPercentage: number | undefined;
  gender: number | undefined;
  days: DrinksPerDay[];
}) => {
  if (targetPercentage !== undefined && gender !== undefined) {
    const units = getUnitsForTargetPercentage(gender, targetPercentage);

    if (units !== undefined) {
      return getCaloriesFromUnitsForEachDay(units);
    }
  }
  return getCaloriesAndUnitsForEachday(days);
};
